import { H1, H2 } from '../reusable-components';
import { useTranslation } from "react-i18next";
import { formatStringCurrency } from "../common/CurrencyFormatter";
import { Box, Grid, Typography } from '@mui/material';
import { PoolXMoney } from '../models/money';
import { IsOrangeLight, themeC } from '../theme/themehelper';

export default function CouponWinHeader({ winAmount, nCorrectRows, isRightToLeft, isHidden }:
  { winAmount: PoolXMoney, nCorrectRows: number, isRightToLeft: boolean, isHidden: boolean }) {

  const { t } = useTranslation();

  const winAmountStr = formatStringCurrency(winAmount.amount, winAmount.currency, t);
  return (
    <Grid container direction="column">
      <Box sx={{
        background: IsOrangeLight(window.theme) ? "#FFF0E0" : window.theme === themeC.Lion ? "#F6F6F6" : "var(--background_4)",
        display: "flex",
        px: "20px",
        flexDirection: "var(--flex-direction)",
        color: window.theme === themeC.Lion ? "#1F1F1F" : "var(--text-black-dark-background)",
        borderBottom: (window.theme === themeC.Lion || IsOrangeLight(window.theme)) ? "1px solid #DDDDDD" : window.theme === themeC.Orange ? "1px solid #575757" : "none",
      }}>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          ...(isRightToLeft
            ? { borderLeft: (window.theme === themeC.Lion || IsOrangeLight(window.theme)) ? "1px solid #DDDDDD" : window.theme === themeC.Orange ? "1px solid #575757" : "1px solid var(--text-black)", pl: "20px" }
            : { borderRight: (window.theme === themeC.Lion || IsOrangeLight(window.theme)) ? "1px solid #DDDDDD" : window.theme === themeC.Orange ? "1px solid #575757" : "1px solid var(--text-black)", pr: "20px" }),
          my: "12px",
        }}>
          <H1 size={110} style={{ lineHeight: "140px", margin: 0, ...(window.theme === themeC.Green && { fontFamily: 'UnibetPro', color: '#111111' }) }}>{nCorrectRows}</H1>
          <Box component="span" sx={{ fontSize: "11px", fontWeight: "bold" }}>
            {t('correct_rows_now')}
          </Box>
        </Box>
        <Box sx={{
          my: "12px",
          ml: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          flexDirection: "var(--flex-direction)",
          width: "100%",
        }}>
          <Box sx={{
            "@media screen and (max-width: 950px)": { mr: "18px" },
          }}>
            <Box component="span" sx={{
              fontSize: "11px",
              mb: "7px",
              display: "block",
              whiteSpace: "nowrap",
            }}>
              {t('your_winnings_right_now')}
            </Box>
            <H2 size={32}>{winAmountStr}</H2>
          </Box>
        </Box>
      </Box>
      {isHidden &&
        <Grid sx={{
          background: "var(--background_4)",
          padding: "20px",
          color: "var(--text-black-dark-background)",
        }}>
          <Typography sx={{ fontWeight: "bold" }}>{t('syndicate_show_later')}</Typography>
        </Grid>
      }
    </Grid>
  );
}